import Form from 'react-bootstrap/Form';
import React, { useState, useEffect, useRef } from "react"
import {useNavigate} from 'react-router-dom';
import Overlay from "react-overlay-component";
import { Link } from "react-router-dom";
import { Vertify } from '@alex_xu/react-slider-vertify';
import CheckboxTnc from '../components/form/CheckboxTnc.js';
import InputMobile from '../components/form/InputMobile.js';
import SelectShop from '../components/form/SelectShop.js';
import PanelDisplayImage from '../components/panel/PanelDisplayImage.js';
import PanelInputMobile from '../components/panel/PanelInputMobile.js';
import PanelSelectShop from '../components/panel/PanelSelectShop.js';
import PanelCheckboxTnc from '../components/panel/PanelCheckboxTnc.js';
import PanelSelectProductQty from '../components/panel/PanelSelectProductQty.js';
import FailTitleDiv from '../components/shared/TitleDiv.js';
import LongButton from '../components/shared/LongButton.js';
import '../css/EnrollM1.css';
import PanelInputRemarks from '../components/panel/PanelInputRemarks.js';
import { EncodeData } from '../components/shared/Aes';

import ImageModal from '../components/modal/ImageModal.js';


function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));

}


function EnrollM1(props) {
    const navigate = useNavigate();
    const PUBLIC_URL =process.env.PUBLIC_URL;
    const url = new URL(window.location.href);
    let baseUrl = `${url.protocol}//${url.host}/`;
    const redPacketEventNames = process.env.REACT_APP_RED_PACKET_EVENT_NAME.split(',');
    const redPacketEventProductImageMapping = JSON.parse(process.env.REACT_APP_RED_PACKET_EVENT_IMAGE_MAPPING);
    
    const stewPotEventNames = process.env.REACT_APP_STEW_POT_EVENT_NAME.split(',');


    if (process.env.REACT_APP_API_URL != ""){
      baseUrl = process.env.REACT_APP_API_URL;
    }
    const eventName = window.name;
    const isRedPacketEvent = redPacketEventNames.includes(eventName);

    const isStewPotEvent = stewPotEventNames.includes(eventName);

    const bgColor = process.env.REACT_APP_BG_COLOR;
    const imgStep1 = process.env.REACT_APP_URL_IMAGE + "step-01.png";
    var clearChildItemsState = null;
    let tracking_channel = "others";

    if(props.isdebugmode) console.log(baseUrl);
    if(window.name==='20260910_crab') navigate('../' + PUBLIC_URL + '/' + eventName + '/fail-internal-event-20260910_crab');
    //navigate('../' + PUBLIC_URL + '/' + eventName + '/enroll');
    if (props.channel !== ""){
      tracking_channel = props.channel;
    }
    const geocodes = [
        {id:1, display: '香港(+852)', value: '852', placeHolder: '例子:55667788', maxLength : 8},
        {id:2, display: '內地(+86)', value: '86', placeHolder: '例子:11122223333', maxLength : 11},
        {id:3, display: '澳門(+853)', value: '853', placeHolder: '例子:55667788', maxLength : 8}
    ];

    const langs = [
      {id:1, display: '需要訂製姓氏', value: 'TC'},
      {id:2, display: '不需訂製姓氏', value: 'NA'}
  ];

    let eventTitle = "產品預購";
    if(isRedPacketEvent) eventTitle = "產品預購  (如在Facebook, Instagram, Messenger或Wechat中訂購利是封出現問題，建議使用外部瀏覽器打開操作)";
    /*
    const rules = [
        {TnC_id: 1, TnC_Description: '所有登記資料以樓上有限公司的電腦紀錄為準。', IsDefault: true},
        {TnC_id: 2, TnC_Description: '本公司將保存閣下所有登記資料以作審核之用，並保存一段合理時間，稍後會將閣下個人資料刪除。', IsDefault: true},
        {TnC_id: 3, TnC_Description: '本人同意將個人資料用作樓上有限公司及樓上(澳門)有限公司登記預購產品用途並已閱讀條款及細則。', IsDefault: true},
        {TnC_id: 4, TnC_Description: '本人同意預購產品於取貨時不設揀貨安排。（所有產品已通過品質檢查，取貨時由樓上分店職員隨機提供）', IsDefault: false}
    ];
    const districts = [
        {Loc_Id:'20002', Loc_Name: 'test',constDisplay_Loc_Id:'20002',Display_Loc_Name: 'test',District:'九龍',IsShown:true},
        {Loc_Id:'20005', Loc_Name: '太子店',constDisplay_Loc_Id:'20005',Display_Loc_Name: '太子店',District:'九龍',IsShown:true},
        {Loc_Id:'20003', Loc_Name: '上水店',Display_Loc_Id:'20003',Display_Loc_Name:'上水店',District:'新界東',IsShown:true},
        {Loc_Id:'20036', Loc_Name: '沙田店',Display_Loc_Id:'20036',Display_Loc_Name:'沙田店',District:'新界東',IsShown:true},
        {Loc_Id:'20039', Loc_Name: '青衣店',Display_Loc_Id:'20039',Display_Loc_Name:'青衣店',District:'新界西',IsShown:true},
        {Loc_Id:'20012', Loc_Name: '屯門店',Display_Loc_Id:'20012',Display_Loc_Name:'屯門店',District:'新界西',IsShown:false},
        {Loc_Id:'21001', Loc_Name: '新馬路澳門廣場店',Display_Loc_Id:'21001',Display_Loc_Name:'新馬路澳門廣場店',District:'澳門區',IsShown:true},
        {Loc_Id:'21002', Loc_Name: '關閘信達廣場店',Display_Loc_Id:'21002',Display_Loc_Name:'關閘信達廣場店',District:'澳門區',IsShown:true}
      ];
    const settings = {
        "Event_Status" : "",
        "Enroll_picture" : "https://www.hkjebn.com/ecoupon/2022_baby_scallop/LT_THEME/default/img/SMS_2_enroll.jpg?cv=0915",
        "Enroll_Button_Wording" : "按此 預購急凍日本煮帶子",
        "Enroll_PreOrder_Method" : "<ol><li>預購程序需時10分鐘，為確保預購的公平性，過程須提供手提電話號碼作核實。</li><li>成功預購後會於1小時內以短訊形式收取確認二維碼。如登記預購電話號碼非本港手提電話號碼，接收訊息時間或會受影響。</li><li>此預購系統不支援Internet Explorer瀏覽器，建議使用Chrome、Safari、Firefox、Wechat或Edge瀏覽器進行預購。</li></ol>若您無法完成登記以獲取確認二維碼，請致電顧客服務熱線查詢(上午9:00 至 晚上9:00)：<br />香港 +852 2300 1800<br />內地 +86 400 120 1339<br />澳門 +853 0800218",
        "Enroll_PreOrder_TnC" : "<ol><li>每人每日每個電話號碼於每預購期內只可以預購1次及最多預購6袋，不可分多次預購。</li><li>此預購推廣適用於香港及澳門區；澳門區忽然驚喜土耳其原色特選無花果 (1磅/袋) 預購價MOP34/袋(原價MOP54/袋)。 <li>於有效期內，憑有效取貨畫面(可接受副本)，經店員核對後方可取貨。</li>每人每日可同時憑最多6個取貨畫面取貨。</li><li>憑有效取貨畫面必須前往畫面上列明之指定分店取貨，不可到非指定分店取貨。</li><li>預購收據不可兌換現金，而每個取貨畫面只可使用1次。</li> <li>預購不可以使用會員卡及會員積分。</li><li>憑取貨畫面取貨時，如會員出示會員卡取貨，可以獲取會員積分。</li><li>必須於有效期內憑有效取貨畫面取貨，逾期不設退款或補貨。</li><li>所有預購條款及詳情以電子收據畫面為準。</li>如有任何爭議，樓上有限公司及樓上(澳門)有限公司保留最終決定權，包括暫停或更改活動期及條款細則，而毋須另行通知。</li></ol>",
        "AllButton_Color" : "#F4405F",
        "AllButton_FontColor" : "#FFFFFF",
        "AllTitle_Color" : "#FFCFDB",
        "AllTitle_FontColor" : "#000000"
    };
    
    const [item_Details, setItem_Details]=useState([
      {"Order_Id": 1,"SubTotal":0,"Item_Code": "88142134","Item_Name": "100%鮮芒果雪條","Item_Spec": "(1支)","Item_Unit": "支","Item_RetailPrice": 22,"Item_ActualPrice": 5,"Item_Min_Qty": 1, "Item_Max_Qty": 6,"Item_POS_Promo_ID": "2022-213, 2022-213R1"},
      {"Order_Id": 2,"SubTotal":0,"Item_Code": "88142135","Item_Name": "100%鮮芒果雪糕4","Item_Spec": "(1杯)","Item_Unit": "杯","Item_RetailPrice": 30,"Item_ActualPrice": 10,"Item_Min_Qty": 0, "Item_Max_Qty": 4,"Item_POS_Promo_ID": "2022-214"}
     ]);
    */
    const [settings, setSettings] = useState({
      Event_Status: "",
      Is_Maintenance: false,
      Event_Picture: "",
      Event_Button_Wording: "",
      Event_PreOrder_Method: "",
      Event_PreOrder_TnC: "",
      AllButton_Color: "",
      AllButton_FontColor: "",
      AllTitle_Color: "#FFFFFF",
      AllTitle_FontColor: "#FFFFFF",
      AllBackground_Color : "#FFFFFF",
      Event_Version: "",
      Event_Name: "" //added by joanne 20250728
    });  
    
    const [isSubmitting, setSubmitting] = useState(false);
    const [rules, setRules] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [orgItem_Details, setOrgItem_Details]=useState([]);
    const [item_Details, setItem_Details]=useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingPreview, setIsLoadingPreview] = useState(false);
    const [totalAmount, setTotalAmount]=useState(0);
    const [isOpenVerify, setIsOpenVerify] = useState(false);
    const [puzzleUrl, setPuzzleUrl] = useState("");
    const [visible, setVisible] = useState(false);
    const [image_Generatation_Status, setImage_Generatation_Status] = useState("");

    
    //Add model image preview 2025-11-28
    // 控制 modal 開關
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Device type: true = mobile / tablet / small screen, false = desktop
    const [isMobile, setIsMobile] = useState(false);
    // const [deviceType, setDeviceType] = useState('Unknown');
    const [modalPreviewImageUrl, setModalPreviewImageUrl] = useState('');

    useEffect(() => {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileUA = /android|iphone|ipad|ipod|windows phone/i.test(ua);
      const isSmallScreen = window.innerWidth < 1024;

      const mobile = isSmallScreen;
      setIsMobile(mobile);
      // setDeviceType(mobile ? 'Mobile / Tablet' : 'Desktop');

      // For console testing
      console.log('UserAgent:', ua);
      console.log(
        'Detected device type:',
        mobile ? 'Mobile / Tablet' : 'Desktop'
      );
    }, []);

    const openModal = () => {
      setIsModalOpen(true);
    };

    const closeModal = () => {
      setIsModalOpen(false);
    };

    //add model image preview 2025-11-28

    const handleClearimage_Generatation_Status= () => {
        //console.log("CHANGE LANG/ REMARK  (BEGORE STATUS)" + image_Generatation_Status);
        setImage_Generatation_Status("");
        //console.log("CHANGE LANG/ REMARK  (AFTER STATUS)" + image_Generatation_Status);
    }

    const handlePreviewTask = (previewurl) => {

      var imageBeforeGenBaseUrl = process.env.REACT_APP_RED_PACKET_EVENT_IMAGE_BEFORE_GEN_URL;
      var imageBeforeGenUrl = imageBeforeGenBaseUrl + "frontend/api/ImageGeneration/TaskWordGeneration"

      const redPacketEventProductImageMapping = JSON.parse(process.env.REACT_APP_RED_PACKET_EVENT_IMAGE_MAPPING);

      var imageProfileIdsTC = redPacketEventProductImageMapping.map(item => item.imageProfileIdTc);
      var imageProfileIdsSC = redPacketEventProductImageMapping.map(item => item.imageProfileIdSc);

      //console.log("image_Generatation_Status: " + image_Generatation_Status);
      //console.log("---------------------------------inputs.remmarks--------------------------"+ inputs.lang + " / " + inputs.lang2 + ";"  + inputs.remarks + " / " + inputs.remarks2 + ";" + containsChinese(inputs.remarks) + " / " + containsChinese(inputs.remarks2)); 
      //Check if the remarks is vaild word
      var msginfo = "不能預覽印刷效果圖，";
      if (!isRedPacketEvent)
      {
          return;
      }
      if (inputs.lang == "" || inputs.lang2 == "" )
      {
        alert(msginfo + "請選擇是否需要訂製姓氏。");
        return;
      }
      else if (inputs.lang != inputs.lang2 || inputs.remarks != inputs.remarks2)
      {
        alert(msginfo + "重覆輸入的訂製姓氏資料不相符。請重新輸入。");
        return;
      }
      else if (inputs.lang != "NA" || inputs.lang2 != "NA")
      {
        if (inputs.remarks == "" || inputs.remarks2 == "") 
        {
          alert(msginfo + "請輸入自訂姓氏。");
          return;
        }
        else 
        {
          if (containsChinese(inputs.remarks) == false || containsChinese(inputs.remarks2) == false)
          {
              alert(msginfo + "輸入的訂製姓氏的不是中文，請重新輸入。");
              return;
          }
        }
      }



      if (image_Generatation_Status === "" || image_Generatation_Status !== "Complete")
      {
  
          let url = imageBeforeGenUrl;
          let postData ={
              "Word" : inputs.remarks,
              "ProfileIdList": (inputs.lang === "TC" ? imageProfileIdsTC : imageProfileIdsSC) //["TC_A1","TC_B1","TC_C1","TC_D1","TC_E1","TC_F1","TC_G1"]
          };
  
          setIsLoadingPreview(true);
  
          const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
          const fetchLoop = () => {
          fetch(url, {
              "method": "POST",
              "headers": {
              'Content-Type': 'application/json'
              },
              "body": JSON.stringify(postData)
          })
          .then(response => response.json())
          .then(response => { 
              let result = JSON.parse(JSON.stringify(response)); 
              //console.log(JSON.stringify(postData));
              //console.log(JSON.stringify(response));
  
              if (result.hasOwnProperty('result')){
                  setImage_Generatation_Status(result.result);
                  // console.log("image_Generatation_Status: (AFTER APIs call, result: )) " + result.result);
  
                  if (result.result !== "Complete") {
                    // Wait 2 seconds before next call
                    delay(2000).then(() => fetchLoop());
                  } 
                  else {
                    // Completed
                    setIsLoadingPreview(false);
                    //window.open(previewurl, '_blank'); 

                    if (isMobile) {
                      setModalPreviewImageUrl(previewurl);
                      openModal();
                    } else {
                      window.open(previewurl, '_blank');
                    }

                    var encodedPreviewUrl = decodeURIComponent(EncodeData(previewurl));
                    
                    //window.open(PUBLIC_URL + '/event-image?srcUrl=' + encodedPreviewUrl);
         
                  }
              } 
              else {
                // No 'result' property, stop loading
                setIsLoadingPreview(false);
              }
          })
          .catch(err => { 
            console.log(err); 
            setIsLoadingPreview(false);
          });
        };
        fetchLoop();
      
      }
        
  };


    const [inputs, setInputs] = useState({
      event_code : "",
      batch_no : "",
      stamp : "",
      code : "",
      geocode : "",
      mobile : "",
      geocode2 : "",
      mobile2 : "",
      lang : "",
      remarks : "",
      lang2 : "",
      remarks2 : "",
      loc_code : "",
      channel : tracking_channel,
      tracking_channel : tracking_channel,
      cbxTncs:[]
    });
      const style = {
        margin: '50px'
      };
    useEffect(() => {
        let GetEventStatusURL = baseUrl + "frontend/api/Enroll/GetEventStatus";
        console.log(GetEventStatusURL);
        fetch(GetEventStatusURL, {
          "method": "POST",
          "headers": {
            'Content-Type': 'application/json'
          },
          "body": JSON.stringify({
            "event_Name": eventName
          })
        })
        .then(response => response.json())
        .then(response => { 
          let result = JSON.parse(JSON.stringify(response));
          if(props.isdebugmode) console.log(result);
          setSettings(previousState => {
            return { 
              ...previousState,
              Event_Status : result.Event_Status,
              Is_Maintenance: result.Is_Maintenance,
              Event_Button_Wording : result.Event_Button_Wording,
              Event_Picture : result.Event_Picture,
              Event_PreOrder_Method : result.Event_PreOrder_Method,
              Event_PreOrder_TnC : result.Event_PreOrder_TnC,
              AllButton_Color : result.AllButton_Color,
              AllButton_FontColor : result.AllButton_FontColor,
              AllTitle_Color : result.AllTitle_Color,
              AllTitle_FontColor : result.AllTitle_FontColor,
              AllBackground_Color : result.AllBackground_Color,
              Event_Version : result.Event_Version,
              Event_Name : eventName //Added by Joanne 20250728
            }
          });

          if (result.Event_Status !== "Processing" && result.Event_Status !== "Testing"){
            navigate('../' + PUBLIC_URL + '/' + eventName + '/enroll');
          }

          // Redirect to enroll page if it is not payment event
          if (result.Event_Version == 3){
            navigate('../' + PUBLIC_URL + '/' + eventName + '/enroll');
          }
        })
        .catch(err => { if(props.isdebugmode) console.log(err); });

        
        let GetEventInfoEnrollURL = baseUrl + "frontend/api/Enroll/GetEventInfoEnroll";
        fetch(GetEventInfoEnrollURL, {
          "method": "POST",
          "headers": {
            'Content-Type': 'application/json'
          },
          "body": JSON.stringify({
            "event_Name": eventName
          })
        })
        .then(response => response.json())
        .then(response => { 
          let result = JSON.parse(JSON.stringify(response));
          if(props.isdebugmode) console.log(result);
          ToDataUrl(result.Image_Setting.Puzzle_Picture, function(myBase64) {
            setPuzzleUrl(myBase64); // myBase64 is the base64 string
            setVisible(true);
          });

          setRules(result.EnrollM1_TnC);
          let newcbxTncs=Array();
          for (var i=0;i<result.EnrollM1_TnC.length;i++)
          {
            newcbxTncs.push({TnC_id:result.EnrollM1_TnC[i].TnC_id,
                             checked: result.EnrollM1_TnC[i].IsDefault});
          }
          setInputs(oldValues => ({...oldValues, cbxTncs: newcbxTncs }));
          let newDistricts= [
            {Loc_Id:'0', Loc_Name: '請選擇',constDisplay_Loc_Id:'',Display_Loc_Name: '',District:'',IsShown:true}]; 

            let newDistrictsWithout202= [
              {Loc_Id:'0', Loc_Name: '請選擇',constDisplay_Loc_Id:'',Display_Loc_Name: '',District:'',IsShown:true}]; 


            if ((eventName == "20251106_stew_pot" || eventName == "20251106_double_bp"))
            {

              newDistrictsWithout202 = result.Location_Detail.filter(location => !location.Loc_Id.startsWith("202"));
              newDistricts = newDistricts.concat(newDistrictsWithout202);

            }
            else
            {
              newDistricts = newDistricts.concat(result.Location_Detail);

            }

          
          let isRegDateExist=false;
          for (var i=0;i<result.Event_Reg_Period.length;i++)
          {
            let Effective_Date = new Date(result.Event_Reg_Period[i].Effective_Date);
            let DateNow= new Date();
            if (Effective_Date.getFullYear() == DateNow.getFullYear() && Effective_Date.getMonth() == DateNow.getMonth() && Effective_Date.getDate() == DateNow.getDate())
            {
              var Batch_No=result.Event_Reg_Period[i].Batch_No;
              setInputs(oldValues => ({...oldValues, batch_no: Batch_No }));
              isRegDateExist=true;
            }
          }
          if (isRegDateExist)
          {
            setDistricts(newDistricts);
            setOrgItem_Details(result.Item_Detail);
          }
        })
        .catch(err => { if(props.isdebugmode) console.log(err); });
      }, []);

      

    const set = name => {
    return ({ target: { value } }) => {
      if (value == null){
        setInputs(oldValues => ({...oldValues, [name]: "" }));
      } else {
        setInputs(oldValues => ({...oldValues, [name]: value }));
      }
    }
  };
  const locationChange = (e) => {
    setTotalAmount(0);
    setInputs(oldValues => ({...oldValues, loc_code: e.target.value }));
    setItem_Details([]);
    let url = baseUrl + "frontend/api/Enroll/GetAvailableItemByLocation";

    
    if (e.target.value !== "0" )
      {
        setIsLoading(true);
      }


      fetch(url, {
        "method": "POST",
        "headers": {
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          "event_Name": eventName,
          "loc_Id": e.target.value
        })
      })
      .then(response => response.json())
      .then(response => { 
        let result = JSON.parse(JSON.stringify(response));
        if(props.isdebugmode) console.log(result);
        
        //let newItem_Details = [...orgItem_Details]; 
        let newItem_Details = []; 
        for (var i=0;i<result.Items.length;i++)
        {
          if(props.isdebugmode) console.log("i am i");
          for (var j=0;j<orgItem_Details.length;j++)
          {
            if(props.isdebugmode) console.log("i am j");
            if (result.Items[i].Item_Code == orgItem_Details[j].Item_Code) 
            {
              if(props.isdebugmode) console.log("i am j if");
              console.log(result.Items[i].Is_Available);
              newItem_Details.push(orgItem_Details[j]);
              newItem_Details[newItem_Details.length-1].SubTotal = 0;
              newItem_Details[newItem_Details.length-1].Available_PickupDate_From=result.Items[i].Available_PickupDate_From;
              newItem_Details[newItem_Details.length-1].Available_PickupDate_To=result.Items[i].Available_PickupDate_To;
              newItem_Details[newItem_Details.length-1].Is_Available=result.Items[i].Is_Available;
            }
          }
        }
        setItem_Details(newItem_Details);
      })
      .catch(err => { console.log(err); })
      .finally(() => {
        setIsLoading(false);
      });
      
      clearChildItemsState();
  }

  const setItemQty = (Item_Code, value) => {
    let newItem_Details = [...item_Details]; 
    var total=0;
      for (var j=0;j<newItem_Details.length;j++)
      {
        if (Item_Code == newItem_Details[j].Item_Code) 
        {
          newItem_Details[j].SelectedQty=value;
          newItem_Details[j].SubTotal=value*newItem_Details[j].Item_ActualPrice;
        }
        total+=newItem_Details[j].SubTotal;
      }
      setTotalAmount(total);
    setItem_Details(newItem_Details);
  }

  function containsChinese(text) {
    const regexTraditional = new RegExp('^[\u4E00-\u9FFF]+$');
    const regexSimplified = new RegExp('^[\u3400-\u4DBF]+$');
    let isTCSC = false;
    if (text != "")
    {
      if (regexTraditional.test(text) || regexSimplified.test(text))
      {
        isTCSC = true;
      }
    }
    
    return isTCSC;
  }


  const submitButtonOnClick = (e) => {
    //if (isSubmitting) return;
    //console.log("geocode/geocode2: " + inputs.geocode + " / " + inputs.geocode);  
    //console.log("lang/lang2: " + inputs.lang + " / " + inputs.lang2);  
    //console.log("remarks/remarks2: " + inputs.remarks + " / " + inputs.remarks2);  

    if (inputs.geocode == "" || inputs.geocode2 == "")
    {
      alert("請選擇區號。");
    }
    else if (inputs.mobile == "" || inputs.mobile2 == "")
    {
      alert("請輸入手提電話號碼。");
    }
    else if (inputs.geocode != inputs.geocode2 || inputs.mobile != inputs.mobile2)
    {
      alert("所輸入的手提電話號碼不相符。請重新輸入。");
    }
    else if (inputs.loc_code == "" || inputs.loc_code == 0)
    {
      alert("請選擇分店。");
    }
    else if (totalAmount == 0)
    {
      alert("請選擇產品。");
    }
    //20251204_red_packet
    else if (isRedPacketEvent &&  (inputs.lang == "" || inputs.lang2 == ""))
    {
      alert("請選擇是否需要訂製姓氏。");
    }
    else if (isRedPacketEvent && (inputs.remarks == "" || inputs.remarks2 == "") && (inputs.lang != "NA" || inputs.lang2 != "NA"))
    {
        alert("請輸入自訂姓氏。");
    }
    else if (isRedPacketEvent && (inputs.lang != inputs.lang2 || inputs.remarks != inputs.remarks2))
    {
      alert("所輸入的自訂姓氏不相符。請重新輸入。");
    }
    else if (isRedPacketEvent && (inputs.lang != "NA" || inputs.lang2 != "NA") && ((inputs.remarks != "" && containsChinese(inputs.remarks) == false) || (inputs.remarks2 != "" && containsChinese(inputs.remarks2) == false)))
    {
        alert("輸入的資料不適用於訂製姓氏的範圍內，請重新輸入。");
    }

    else
    {
      var isSuccess = true;

      //for (var i=0;i<item_Details.length;i++)
      //{
        
        //if (item_Details[i].Item_Min_Qty != 0 && item_Details[i].SubTotal == 0)
        //{
        //  isSuccess=false;
        //  alert(item_Details[i].Item_Name + "必須選購。");
       // }
      //}
      
      /*if (eventName == process.env.REACT_APP_STEW_POT_EVENT_NAME)
     {
        var CountQty = 0;
        for (let j = 0; j < item_Details.length; j++) 
        {
            const item = item_Details[j];
            CountQty += parseInt(item.SelectedQty) || 0;
        }
  
        if (CountQty > 1)
        {
          isSuccess=false;
          alert("只可選購其中一款產品。");
        }
      }*/



      //APPLY RESET BUTTON AND Min_Qty has no 0
      var CountQty = 0;

      for (let i = 0; i < item_Details.length; i++) 
      {
        const item = item_Details[i];
        CountQty += parseInt(item.SelectedQty) || 0;
      }

      if (CountQty === 0)
      {
        isSuccess=false;
        alert("請選擇產品。");
        return false;
      }
      else if (CountQty > 1)
      {
        if (eventName == process.env.REACT_APP_STEW_POT_EVENT_NAME)
        {
          isSuccess=false;
          alert("只可選購其中一款產品。");
          return false;

        }

      }


      //cbxTnc
      for (var i=0;i<inputs.cbxTncs.length;i++)
      {
        if (!inputs.cbxTncs[i].checked)
        {
          isSuccess=false;
          alert("請同意所有條款。");
          return false;
        }
      }

      if (isRedPacketEvent) //利是封, SKIP PUZZLE & HAVE COMFIRMATION BOX
      {
        const confirmed = window.confirm('請確認已預覽印刷效果圖？');
        if (!confirmed) 
        { 
          isSuccess = false;
        }
      }


      if (isSuccess)
      {
        if (!isRedPacketEvent) 
        {
          setIsOpenVerify(true);
          setSubmitting(true);
        }
        else
        {
          setSubmitting(true);
          VertifyonSuccess();
        }

      }
    }
  }

  const VertifyonSuccess = (e) => {
    var Base_url = window.location.protocol + "//" + window.location.host+process.env.PUBLIC_URL+"/"+window.name+"/PaymentResult";
    let url = baseUrl + "frontend/api/Enroll/InsertEventRegistration";
    let postData ={
      "Event_Name" : eventName,
      "Geocode": inputs.geocode,
      "Mobile": inputs.mobile,
      "Loc_Code": inputs.loc_code,
      "Loc_Name" : "test",
      "Total_Amount_Mo_Str" : "MOP 20",
      "Order_Item": {
          "Item_Detail":[
             ]
      },
      "Channel": inputs.channel,
      "Tracking_Channel": inputs.tracking_channel,
      "batch_No": inputs.batch_no,
      "Base_url": Base_url,
      "Is_allow_online_payment": true,
      "Is_allow_offline_payment": false,
      "CreatedBy": "Web",
      "Remark01": inputs.lang,
      "Remark02": inputs.remarks,
      "Remark03": "",
      "Remark04": "",
      "Remark05": "",
      "isSelfServe": false
    };
    for (var i=0;i<item_Details.length;i++)
    {
      
      if (item_Details[i].SelectedQty > 0 && item_Details[i].SubTotal > 0)
      {
        let items={"Item_Code": item_Details[i].Item_Code,"Item_Qty": item_Details[i].SelectedQty,"Item_ActualPrice": item_Details[i].Item_ActualPrice,"Item_TotalPrice": item_Details[i].SubTotal}
        postData.Order_Item.Item_Detail.push(items);
      }
    }
    
    fetch(url, {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json'
      },
      "body": JSON.stringify(postData)
    })
    .then(response => response.json())
    .then(response => { 
      let result = JSON.parse(JSON.stringify(response));
      //alert(JSON.stringify(response));  
      if(props.isdebugmode) console.log(JSON.stringify(postData));
      if(props.isdebugmode) console.log(JSON.stringify(response));
      if (result.hasOwnProperty('invoice_url')){
        // setInputs({ 
        //   geocode : "",
        //   mobile : "",
        //   geocode2 : "",
        //   mobile2 : "",
        //   loc_code : "",
        // });
        console.log("clean");
        window.location = result.invoice_url;
      }
        
      if (result.hasOwnProperty('IsSuccess')){
        if(props.isdebugmode) alert(result.ErrorMessage);
        if (result.ErrorCode === 10012){
          navigate('../' + PUBLIC_URL + '/' + eventName + '/fail-duplicate');
        } else if (result.ErrorCode === 10514){
          navigate('../' + PUBLIC_URL + '/' + eventName + '/fail-wrong-format');
        } else if (result.ErrorCode === 10518 || result.ErrorCode === 10005 || result.ErrorCode === 10007){
          navigate('../' + PUBLIC_URL + '/' + eventName + '/fail-full-quota');
        } else {
          navigate('../' + PUBLIC_URL + '/' + eventName + '/fail-reg-error?errcode=' + result.ErrorCode);
        }        
      }        
    })
    .catch(err => { console.log(err); setSubmitting(false); });
    
    setIsOpenVerify(false);
  }
  const VertifyonFail = (e) => {

  }
  const VertifyonRefresh = (e) => {

  }
  const checkboxOnChange = (e) => {
    var newcbxTncs=[...inputs.cbxTncs];
    for (var i=0;i<newcbxTncs.length;i++)
    {
      if (("cbxTnc"+newcbxTncs[i].TnC_id) == e.target.name)
      {
        newcbxTncs[i].checked = e.target.checked;
        setInputs(oldValues => ({...oldValues, cbxTncs: newcbxTncs }));
        break;
      }
    }
  }
  const ClearSelectedItems = (childClearSelectedItems) => {
    clearChildItemsState = childClearSelectedItems;
  }

  return (
    <>
        <Overlay configs={{animate: true}} isOpen={isOpenVerify} closeOverlay={()=>setIsOpenVerify(false)}>
        <p></p>
        <Vertify
            className={style}
            imgUrl={puzzleUrl}
            text="向右拉箭咀以完成上方拼圖"
            width={320}
            height={180}
            visible={visible}
            onSuccess={() => VertifyonSuccess()}
            onFail={() => VertifyonFail()}
            onRefresh={() => VertifyonRefresh()}
        />
        </Overlay>
        <Form>
        {
            (isLoading || isLoadingPreview) &&  
            <div className="d-flex flex-column Location_Loader">  
              <div class="row">
                  <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                  </div>
              </div>
              <br/>
              <div class="row">
                {isLoading && <strong>加載中，請耐心等待</strong>}
                {isLoadingPreview && <strong>印刷效果圖製作中，請耐心等侯</strong>}
              </div>
            </div>
          }


                <FailTitleDiv class="title" title={eventTitle} bgColor={settings.AllTitle_Color} fontColor={settings.AllTitle_FontColor}></FailTitleDiv>
                <div className="d-grid" style={{backgroundColor: settings.AllBackground_Color}}>
                    <PanelDisplayImage imagesrc={imgStep1}></PanelDisplayImage>
                    <PanelInputMobile geoList={geocodes} setGeocode={set('geocode')} setMobile={set('mobile')} setRepeatGeocode={set('geocode2')} setRepeatMobile={set('mobile2')}></PanelInputMobile>
                    <PanelSelectShop districtsList={districts} onChange={locationChange}></PanelSelectShop>
                    {
                      isRedPacketEvent && 
                      <>
                        <PanelInputRemarks step="3" langList={langs} setLang={set('lang')} setRemarks={set('remarks')} setRepeatLang={set('lang2')} setRepeatRemarks={set('remarks2')} handleClearimage_Generatation_Status={handleClearimage_Generatation_Status} ></PanelInputRemarks>
                      </>
                    }
                    <PanelSelectProductQty passClearSelectedItems={ClearSelectedItems} item_Details={item_Details} totalAmount={totalAmount} setItemQty={(Item_Code, value) =>setItemQty(Item_Code, value)} isShowScanInput={false} redPacketEventProductImageMapping={redPacketEventProductImageMapping} isRedPacketEvent={isRedPacketEvent} isStewPotEvent={isStewPotEvent} remarks={inputs.remarks} lang={inputs.lang} image_Generatation_Status={image_Generatation_Status} handlePreviewTask={handlePreviewTask}  ></PanelSelectProductQty>
                  
                    <PanelCheckboxTnc tncList={rules} checkboxOnChange={checkboxOnChange}></PanelCheckboxTnc>
                    {
                      settings.AllButton_Color !== '' && <LongButton class="enroll-button" text="確認訂單" bgColor={settings.AllButton_Color} fontColor={settings.AllButton_FontColor}  onClick={() => { submitButtonOnClick(); }} ></LongButton>
                    }
                </div>
        </Form>
        <div style={{ marginTop: '1rem' }}>
          <ImageModal
            isOpen={isModalOpen}
            src={modalPreviewImageUrl}
            onClose={closeModal}
          />
        </div>
    </>
  );
}

function ToDataUrl(url, callback) {
  var xhr = new XMLHttpRequest();
  xhr.onload = function() {
      var reader = new FileReader();
      reader.onloadend = function() {
          callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.setRequestHeader("Cache-Control", "no-cache");
  xhr.responseType = 'blob';
  xhr.send();
}

export default EnrollM1;
